<template>
  <div
    v-if="openItem && isCompactViewport"
    class="sidebar-mobile-backdrop"
    @click="openItem = null"
  ></div>
  <div
    id="sidebar-wrap"
    class="sidebar-area position-fixed bg_primary transition"
  >
    <div id="sidebar_menu_wrap" class="sidebar-menu-wrap">
      <ul class="sidebar-menu list-style">
        <li class="nav-item">
          <router-link to="/" class="nav-link">
            <img src="../../assets/img/icons/dashboard.svg" alt="Image" />
            <span class="nav-text d-block fs-14 fw-light"> {{ $t('dashboard') }} </span>
          </router-link>
        </li>
        <li class="nav-item" v-permission="'product_index'" :class="{ open:openItem === 'products' }">
          <a href="javascript:void(0)" class="nav-link" @click="toggleOpen('products')">
            <img src="../../assets/img/icons/products.svg" alt="Image" />
            <span class="nav-text d-block fs-14"> {{ $t('products') }} </span>
          </a>
          <ul class="sidebar-secondary-menu list-style bg-white">
            <li class="nav-item" v-permission="'product_create'">
              <router-link to="/create-product">
                <img src="../../assets/img/icons/create-item.svg" alt="Image" />
                {{ $t('create_product') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'product_index'">
              <router-link to="/product-list">
                <img src="../../assets/img/icons/item-list.svg" alt="Image" />
                {{ $t('product_list') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'product_barcode'">
              <router-link to="/print-barcode">
                <img src="../../assets/img/icons/barcode.svg" alt="Image" />
                {{ $t('print_barcode') }}
              </router-link>
            </li>
          </ul>
        </li>
        <li class="nav-item" v-permission="'adjustment_index'" :class="{ open:openItem === 'adjustments' }">
          <a href="javascript:void(0)" class="nav-link" @click="toggleOpen('adjustments')">
            <img src="../../assets/img/icons/adjustments.svg" alt="Image" />
            <span class="nav-text d-block fs-14"> {{ $t('adjustments') }} </span>
          </a>
          <ul class="sidebar-secondary-menu bg-white list-style">
            <li class="nav-item" v-permission="'adjustment_create'">
              <router-link to="/create-adjustment">
                <img src="../../assets/img/icons/create-item.svg" alt="Image" />
                {{ $t('create_adjustment') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'adjustment_index'">
              <router-link to="/adjustment-list">
                <img src="../../assets/img/icons/item-list.svg" alt="Image" />
                {{ $t('adjustment_list') }}
              </router-link>
            </li>
          </ul>
        </li>
        <li class="nav-item" v-permission="'movement_index'" :class="{ open:openItem === 'transfer' }">
          <a href="javascript:void(0)" class="nav-link" @click="toggleOpen('transfer')">
            <img src="../../assets/img/icons/transfer.svg" alt="Image" />
            <span class="nav-text d-block fs-14"> {{ $t('transfer') }} </span>
          </a>
          <ul class="sidebar-secondary-menu bg-white list-style">
            <li class="nav-item" v-permission="'movement_create'">
              <router-link to="/create-transfer">
                <img src="../../assets/img/icons/create-item.svg" alt="Image" />
                {{ $t('create_transfer') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'movement_index'">
              <router-link to="/transfer-list">
                <img src="../../assets/img/icons/item-list.svg" alt="Image" />
                {{ $t('transfer_list') }}
              </router-link>
            </li>
          </ul>
        </li>
        <li class="nav-item" v-permission="'expense_index'" :class="{ open:openItem === 'finance' }">
          <a href="javascript:void(0)" class="nav-link" @click="toggleOpen('finance')">
            <img src="../../assets/img/icons/expenses.svg" alt="Image" />
            <span class="nav-text d-block fs-14"> {{ $t('finance') }} </span>
          </a>
          <ul class="sidebar-secondary-menu bg-white list-style">
            <li class="nav-item" v-permission="'expense_create'">
              <router-link to="/create-expense">
                <img src="../../assets/img/icons/create-item.svg" alt="Image" />
                {{ $t('create_expense') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'expense_index'">
              <router-link to="/expense-list">
                <img src="../../assets/img/icons/item-list.svg" alt="Image" />
                {{ $t('expense_list') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'expense_category_index'">
              <router-link to="/expense-category">
                <img
                  src="../../assets/img/icons/expense-category.svg"
                  alt="Image"
                />
                {{ $t('expense_category') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'expense_create'">
              <router-link to="/create-income">
                <img src="../../assets/img/icons/create-item.svg" alt="Image" />
                {{ $t('create_income') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'expense_index'">
              <router-link to="/income-list">
                <img src="../../assets/img/icons/item-list.svg" alt="Image" />
                {{ $t('income_list') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'expense_category_index'">
              <router-link to="/income-category">
                <img src="../../assets/img/icons/expense-category.svg" alt="Image" />
                {{ $t('income_category') }}
              </router-link>
            </li>
          </ul>
        </li>
        <li class="nav-item" v-permission="'quote_index'" :class="{ open:openItem === 'quotations' }">
          <a href="javascript:void(0)" class="nav-link" @click="toggleOpen('quotations')">
            <img src="../../assets/img/icons/quotation.svg" alt="Image" />
            <span class="nav-text d-block fs-14"> {{ $t('quotations') }} </span>
          </a>
          <ul class="sidebar-secondary-menu bg-white list-style">
            <li class="nav-item" v-permission="'quote_create'">
              <router-link to="/create-quotation">
                <img src="../../assets/img/icons/create-item.svg" alt="Image" />
                {{ $t('create_quotation') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'quote_index'">
              <router-link to="/quotation-list">
                <img src="../../assets/img/icons/item-list.svg" alt="Image" />
                {{ $t('quotation_list') }}
              </router-link>
            </li>
          </ul>
        </li>
        <li class="nav-item" v-permission="'purchase_index'" :class="{ open:openItem === 'purchases' }">
          <a href="javascript:void(0)" class="nav-link" @click="toggleOpen('purchases')">
            <img src="../../assets/img/icons/purchase.svg" alt="Image" />
            <span class="nav-text d-block fs-14"> {{ $t('purchases') }} </span>
          </a>
          <ul class="sidebar-secondary-menu bg-white list-style">
            <li class="nav-item" v-permission="'purchase_create'">
              <router-link to="/create-purchase">
                <img src="../../assets/img/icons/create-item.svg" alt="Image" />
                {{ $t('create_purchase') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'purchase_index'">
              <router-link to="/purchase-list">
                <img src="../../assets/img/icons/item-list.svg" alt="Image" />
                {{ $t('purchase_list') }}
              </router-link>
            </li>
          </ul>
        </li>
        <li class="nav-item" v-permission="'sale_index'" :class="{ open:openItem === 'sales' }">
          <a href="javascript:void(0)" class="nav-link" @click="toggleOpen('sales')">
            <img src="../../assets/img/icons/sale.svg" alt="Image" />
            <span class="nav-text d-block fs-14"> {{ $t('sales') }} </span>
          </a>
          <ul class="sidebar-secondary-menu bg-white list-style">
            <li class="nav-item" v-permission="'sale_create'">
              <router-link to="/create-sales">
                <img src="../../assets/img/icons/create-item.svg" alt="Image" />
                {{ $t('create_sale') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'sale_index'">
              <router-link to="/sales-list">
                <img src="../../assets/img/icons/item-list.svg" alt="Image" />
                {{ $t('sales_list') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'sale_create'">
              <router-link to="/create-sales-return">
                <img src="../../assets/img/icons/create-item.svg" alt="Image" />
                {{ $t('create_sales_return') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'sale_index'">
              <router-link to="/sales-return-list">
                <img src="../../assets/img/icons/item-list.svg" alt="Image" />
                {{ $t('sales_return_list') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'pos_sale_index'">
              <router-link to="/pos-sales-list">
                <img src="../../assets/img/icons/item-list.svg" alt="Image" />
                {{ $t('pos_sales_list') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'pos_sale_index'">
              <router-link to="/pos/queue">
                <img src="../../assets/img/icons/item-list.svg" alt="Image" />
                {{ $t('pos.waiting_queue') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'pos_sale_index'">
              <router-link to="/pos">
                <img src="../../assets/img/icons/item-list.svg" alt="Image" />
                {{ $t('pos_screen') }}
              </router-link>
            </li>
          </ul>
        </li>
        <li class="nav-item" v-permission="'people_index'" :class="{ open:openItem === 'people' }">
          <a href="javascript:void(0)" class="nav-link" @click="toggleOpen('people')">
            <img src="../../assets/img/icons/adjustments.svg" alt="Image" />
            <span class="nav-text d-block fs-14"> {{ $t('people') }} </span>
          </a>
          <ul class="sidebar-secondary-menu bg-white list-style">
            <li class="nav-item" v-permission="'customer_index'">
              <router-link to="/customer-list">
                <img src="../../assets/img/icons/user-square.svg" alt="Image" />
                {{ $t('customer_list') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'supplier_index'">
              <router-link to="/supplier-list">
                <img src="../../assets/img/icons/item-list.svg" alt="Image" />
                {{ $t('supplier_list') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'role_index'">
              <router-link to="/user-list">
                <img
                  src="../../assets/img/icons/profile-circle.svg"
                  alt="Image"
                />
                {{ $t('user_list') }}
              </router-link>
            </li>
          </ul>
        </li>
        <li class="nav-item" v-permission="'setting_index'" :class="{ open:openItem === 'settings' }">
          <a href="javascript:void(0)" class="nav-link" @click="toggleOpen('settings')">
            <img src="../../assets/img/icons/setting-2.svg" alt="Image" />
            <span class="nav-text d-block fs-14"> {{ $t('settings') }} </span>
          </a>
          <ul class="sidebar-secondary-menu bg-white list-style">
            <li class="nav-item" v-permission="'setting_index'">
              <router-link to="/system-settings">
                <img src="../../assets/img/icons/setting-3.svg" alt="Image" />
                {{ $t('system_settings') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'role_permission'">
              <router-link to="/group-permission">
                <img src="../../assets/img/icons/group.svg" alt="Image" />
                {{ $t('group_permission') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'warehouse_index'">
              <router-link to="/warehouse-list">
                <img src="../../assets/img/icons/warehouse.svg" alt="Image" />
                {{ $t('warehouse') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'category_index'">
              <router-link to="/category-list">
                <img src="../../assets/img/icons/category.svg" alt="Image" />
                {{ $t('category') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'brand_index'">
              <router-link to="/brand-list">
                <img src="../../assets/img/icons/brand.svg" alt="Image" />
                {{ $t('brand') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'currency_index'">
              <router-link to="/currency-list">
                <img src="../../assets/img/icons/currency.svg" alt="Image" />
                {{ $t('currency') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'unit_index'">
              <router-link to="/unit-list">
                <img src="../../assets/img/icons/unit.svg" alt="Image" />
                {{ $t('unit') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'product_index'">
              <router-link to="/size-list">
                <img src="../../assets/img/icons/unit.svg" alt="Image" />
                {{ $t('size') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'product_index'">
              <router-link to="/sugar-list">
                <img src="../../assets/img/icons/unit.svg" alt="Image" />
                {{ $t('sugar') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'coupon_index'">
              <router-link to="/coupon-list">
                <img src="../../assets/img/icons/dollar-circle.svg" alt="Image" />
                {{ $t('coupon') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'membership_card_index'">
              <router-link to="/membership-cards">
                <img src="../../assets/img/icons/dollar-circle.svg" alt="Image" />
                {{ $t('membership_card') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'promotion_index'">
              <router-link to="/promotion-list">
                <img src="../../assets/img/icons/dollar-circle.svg" alt="Image" />
                {{ $t('promotion') }}
              </router-link>
            </li>
          </ul>
        </li>
        <li class="nav-item" v-permission="'report_sale'" :class="{ open:openItem === 'reports' }">
          <a href="javascript:void(0)" class="nav-link" @click="toggleOpen('reports')">
            <img src="../../assets/img/icons/reports.svg" alt="Image" />
            <span class="nav-text d-block fs-14"> {{ $t('reports') }} </span>
          </a>
          <ul class="sidebar-secondary-menu bg-white list-style">
            <li class="nav-item" v-permission="'report_purchase'">
              <router-link to="/purchase-report">
                <img src="../../assets/img/icons/purchase-2.svg" alt="Image" />
                {{ $t('purchase_report') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'report_payment'">
              <router-link to="/purchase-payment-report">
                <img
                  src="../../assets/img/icons/purchase-payment.svg"
                  alt="Image"
                />
                {{ $t('purchase_payment_report') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'report_sale'">
              <router-link to="/sales-report">
                <img src="../../assets/img/icons/money-3.svg" alt="Image" />
                {{ $t('sales_report') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'report_sale'">
              <router-link to="/pos-sales-report">
                <img src="../../assets/img/icons/money-3.svg" alt="Image" />
                {{ $t('pos_sales_report') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'report_payment'">
              <router-link to="/sales-payment-report">
                <img src="../../assets/img/icons/money-3.svg" alt="Image" />
                {{ $t('sales_payment_report') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'report_payment'">
              <router-link to="/pos-sales-payment-report">
                <img src="../../assets/img/icons/money-3.svg" alt="Image" />
                {{ $t('pos_sales_payment_report') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'report_sale'">
              <router-link to="/sales-return-report">
                <img
                  src="../../assets/img/icons/sales-return-2.svg"
                  alt="Image"
                />
                {{ $t('sales_return_report') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'report_stock'">
              <router-link to="/product-quantity-alert">
                <img
                  src="../../assets/img/icons/quantity-alert.svg"
                  alt="Image"
                />
                {{ $t('product_quantity_alert') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'report_pnl'">
              <router-link to="/profit-loss">
                <img
                  src="../../assets/img/icons/dollar-circle.svg"
                  alt="Image"
                />
                {{ $t('profit_loss') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'report_stock'">
              <router-link to="/product-report">
                <img src="../../assets/img/icons/create-item.svg" alt="Image" />
                {{ $t('product_report') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'report_stock'">
              <router-link to="/stock-report">
                <img src="../../assets/img/icons/category.svg" alt="Image" />
                {{ $t('stock_report') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'report_warehouse'">
              <router-link to="/warehouse-report">
                <img
                  src="../../assets/img/icons/warehouse-report.svg"
                  alt="Image"
                />
                {{ $t('warehouse_report') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'report_customer'">
              <router-link to="/customer-report">
                <img
                  src="../../assets/img/icons/customer-report.svg"
                  alt="Image"
                />
                {{ $t('customer_report') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'report_supplier'">
              <router-link to="/supplier-report">
                <img
                  src="../../assets/img/icons/customer-report.svg"
                  alt="Image"
                />
                {{ $t('supplier_report') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'report_user'">
              <router-link to="/user-report">
                <img src="../../assets/img/icons/user-square.svg" alt="Image" />
                {{ $t('user_report') }}
              </router-link>
            </li>
            <li class="nav-item" v-permission="'report_sale'">
              <router-link to="/register-history">
                <img src="../../assets/img/icons/rotate-left.svg" alt="Image" />
                {{ $t('register_history') }}
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainSidebar",
  data() {
    return {
      openItem: null,
      isCompactViewport: false,
    };
  },
  watch: {
    $route() {
      this.openItem = null;
    },
  },
  mounted() {
    this.openItem = null;
    this.handleViewportChange();
    document.addEventListener("click", this.handleOutsideClick, true);
    window.addEventListener("resize", this.handleViewportChange, { passive: true });
  },
  unmounted() {
    document.removeEventListener("click", this.handleOutsideClick, true);
    window.removeEventListener("resize", this.handleViewportChange);
  },
  methods: {
    toggleOpen(key) {
      this.openItem = this.openItem === key ? null : key;
    },
    handleViewportChange() {
      this.isCompactViewport = window.innerWidth <= 1199;
    },
    handleOutsideClick(e) {
      const root = this.$el;
      if (root && !root.contains(e.target)) {
        this.openItem = null;
      }
    },
    getKeyForRoute(path) {
      const mapping = [
        { key: "products", routes: ["/create-product", "/product-list", "/print-barcode"] },
        { key: "adjustments", routes: ["/create-adjustment", "/adjustment-list"] },
        { key: "transfer", routes: ["/create-transfer", "/transfer-list"] },
        { key: "finance", routes: ["/create-expense", "/expense-list", "/expense-category", "/create-income", "/income-list", "/income-category"] },
        { key: "quotations", routes: ["/create-quotation", "/quotation-list"] },
        { key: "purchases", routes: ["/create-purchase", "/purchase-list"] },
        { key: "sales", routes: ["/create-sales", "/sales-list", "/edit-sales", "/create-sales-return", "/sales-return-list", "/pos-sales-list", "/pos/queue", "/pos"] },
        { key: "people", routes: ["/customer-list", "/supplier-list", "/user-list"] },
        {
          key: "settings",
          routes: [
            "/system-settings",
            "/group-permission",
            "/warehouse-list",
            "/category-list",
            "/brand-list",
            "/currency-list",
            "/unit-list",
            "/size-list",
            "/sugar-list",
            "/coupon-list",
            "/membership-cards",
            "/promotion-list",
          ],
        },
        {
          key: "reports",
          routes: [
            "/purchase-report",
            "/purchase-payment-report",
            "/sales-report",
            "/pos-sales-report",
            "/sales-payment-report",
            "/pos-sales-payment-report",
            "/product-quantity-alert",
            "/profit-loss",
            "/product-report",
            "/stock-report",
            "/warehouse-report",
            "/customer-report",
            "/supplier-report",
            "/user-report",
            "/register-history",
          ],
        },
      ];
      for (const m of mapping) {
        if (m.routes.some((r) => path.startsWith(r))) return m.key;
      }
      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar-mobile-backdrop {
  position: fixed;
  inset: 0;
  z-index: 5;
  background: rgba(15, 23, 42, 0.28);
  backdrop-filter: blur(2px);
}

.sidebar-area {
  top: 100px;
  left: 0;
  height: 100%;
  z-index: 6;
  transition: var(--transition);
  .sidebar-menu-wrap {
    padding: 40px;
    z-index: 2;
    .sidebar-menu {
      position: relative;
      z-index: 2;
      & > .nav-item {
        margin-bottom: 25px;
        display: block;
        &:last-child {
          margin-bottom: 0;
        }
        & > .nav-link {
          position: relative;
          background-color: #2c3a52;
          text-align: center;
          display: inline-block;
          width: 128px;
          height: 100px;
          border-radius: 4px;
          padding: 19px 5px 18px;
          transition: var(--transition);
          z-index: 1;

          &:after {
            position: absolute;
            bottom: 0;
            left: 0;
            content: "";
            width: 100%;
            height: 0;
            border-radius: 4px;
            background: var(
              --Purple-Gradient,
              linear-gradient(132deg, #4f46e5 4.27%, #6366f1 100%)
            );
            visibility: hidden;
            opacity: 0;
            transition: var(--transition);
            z-index: -1;
          }
          img {
            display: block;
            margin: 0 auto;
          }
          .nav-text {
            color: #c6c7d3;
            margin-top: 5px;
          }
          &.active {
            &:after {
              visibility: visible;
              opacity: 1;
              height: 100%;
            }
          }
        }
        &.active,
        // &:hover {
        &.open{
          & > .nav-link {
            &:after {
              visibility: visible;
              opacity: 1;
              height: 100%;
            }
          }
        }
        &:has(ul.sidebar-secondary-menu li a.active) {
          & > .nav-link {
            &:after {
              visibility: visible;
              opacity: 1;
              height: 100%;
            }
          }
        }
        .sidebar-secondary-menu {
          position: fixed;
          top: 100px;
          left: 208px;
          width: 280px;
          height: calc(100vh - 100px);
          visibility: hidden;
          opacity: 0;
          transition: var(--transition);
          z-index: 8;
          overflow-y: auto;
          box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.06);
          li {
            a {
              font-size: 14px;
              color: var(--primaryColor);
              transition: var(--transition);
              padding: 14px 25px;
              display: block;
              width: 100%;
              img {
                position: relative;
                margin-right: 8px;
                top: -1.5px;
              }
              &.active,
              &:hover {
                background-color: #f3f8ff;
              }
            }
          }
        }
        // &:hover {
        &.open{
          .sidebar-secondary-menu {
            visibility: visible;
            opacity: 1;
          }
        }
      }
    }
  }
}
#sidebar_menu_wrap {
  position: relative;
  z-index: 1;
  height: calc(100vh - 100px);
  overflow-y: auto;
  &::-webkit-scrollbar {
    height: 7px;
    width: 7px;
    background: var(--primaryColor);
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.5);
    -webkit-border-radius: 1ex;
    -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.75);
  }
  &::-webkit-scrollbar-corner {
    background: #000;
  }
}

@media only screen and (max-width: 575px) {
  .sidebar-area {
    top: 116px;
    .sidebar-menu-wrap {
      padding: 25px 15px;
      .sidebar-menu {
        & > .nav-item {
          margin-bottom: 10px;
          &:last-child {
            margin-bottom: 0;
          }
          & > .nav-link {
            width: 55px;
            height: 55px;
            padding: 14px 5px 12px;
            img {
              max-width: 27px;
            }
            .nav-text {
              display: none !important;
            }
          }
          .sidebar-secondary-menu {
            top: 116px;
            left: 80px;
            width: min(280px, calc(100vw - 96px));
            max-width: calc(100vw - 96px);
            height: calc(100vh - 132px);
            border-radius: 0 18px 18px 0;
            li {
              a {
                font-size: 14px;
                padding: 14px 20px;
              }
            }
          }
        }
      }
    }
  }
  #sidebar_menu_wrap {
    height: calc(100vh - 116px);
  }
}

@media only screen and (min-width: 576px) and (max-width: 767px) {
  .sidebar-area {
    top: 80px;
    .sidebar-menu-wrap {
      .sidebar-menu {
        & > .nav-item {
          .sidebar-secondary-menu {
            top: 79px;
            left: 104px;
            width: min(300px, calc(100vw - 128px));
            max-width: calc(100vw - 128px);
            height: calc(100vh - 103px);
            border-radius: 0 18px 18px 0;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 1199px) {
  .sidebar-area {
    .sidebar-menu-wrap {
      .sidebar-menu {
        & > .nav-item {
          .sidebar-secondary-menu {
            left: 104px;
            width: min(320px, calc(100vw - 128px));
            max-width: calc(100vw - 128px);
            height: calc(100vh - 124px);
            border-radius: 0 20px 20px 0;
            box-shadow: 0 20px 45px rgba(15, 23, 42, 0.18);
          }
        }
      }
    }
  }
}
</style>
